<template>
  <div id="app">
    <headerElem />
    <transition name="fade" mode="out-in">
      <router-view />
    </transition>
    <FooterElem />
    <!-- nosemgrep: javascript.vue.security.audit.xss.templates.avoid-v-html.avoid-v-html -->
    <span v-if="style" v-html="$sanitizeStyle(style)"></span>
  </div>
</template>

<script>
import HeaderElem from "@/components/Header";
import FooterElem from "@/components/Footer";

export default {
  name: "App",
  data: function () {
    return {
      datas: this.$root.configOp.datas,
      style: undefined,
    };
  },
  mounted() {
    if (!this.datas) {
      if (this.$route.path != "/404") {
        this.$router.push(`/404`);
      }
    }
    if (this.datas && this.datas.custom && this.datas.custom.cssRules) {
      this.style = `<style lang="scss">${this.datas.custom.cssRules}</style>`;
    }
  },
  components: {
    HeaderElem,
    FooterElem,
  },
};
</script>

<style>
input[type="radio"] {
  margin-right: 5px !important;
}

#reward_element {
  display: flex !important;
  gap: 20px !important;
}
</style>
